// extracted by mini-css-extract-plugin
module.exports = {"button-arrow":"styles_button-arrow__q3ip1","inner":"styles_inner__LUme_","expand":"styles_expand__zRPmD"};